/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';
interface ITopic1400Props {
  settings: any;
}

const Topic1400: React.FunctionComponent<ITopic1400Props> = ({ settings }) => (
  <TopicContainer className="t1400">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem id="2" className="topic-item t1400_2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem id="3" className="topic-item t1400_3">
      <Section2 settings={settings} />
    </TopicItem>
    <TopicItem id="4" className="topic-item t1400_4">
      <Section3 settings={settings} />
    </TopicItem>
    <TopicItem id="5" className="topic-item t1400_5">
      <Section4 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default Topic1400;
